module.exports = __webpack_public_path__ + "static/media/user.333cc8db.svg";